export let Integration;

(function (Integration) {
  Integration["DesignKitGenerator"] = "design-kit-generator";
  Integration["Wordpress"] = "wordpress";
  Integration["Wpforms"] = "wpforms";
  Integration["Shopify"] = "shopify";
  Integration["Typeform"] = "typeform";
})(Integration || (Integration = {}));